import { Base } from '../base-component';
import './content-display-cards-icons-with-image.component.scss';

export class ContentDisplayCardsIconsWithImage extends Base {

	constructor(element: Element){

		super(element);

	}

	init(){

	}

	bindEvents() {

	}

}


// WEBPACK FOOTER //
// ./components/content-display-cards-icons-with-image/content-display-cards-icons-with-image.component.ts